import React from "react";
import { Link } from "gatsby";
import Img from "gatsby-image";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Container from "../components/container";
import styled from "@emotion/styled"
import { FaGithub } from "react-icons/fa"
import faker from "faker";

const Styles = styled.div`
padding: 84px 0px;
  min-height: 100vh;

  .my-courses {
    display: grid;
    grid-gap: 36px;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr))
  }

  .gatsby-image-wrapper {
    border-bottom: 1px solid #ccc;
    height: 165px;
  }

  .subtitle {
    margin-bottom: 8px;
  }

  .card {
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  .card-content {
    padding: 14px;
  }

  
`

export default class extends React.Component {
  constructor () {
    super();
    this.state = {}
  }

  render () {
    let courses = [
      
      {
        title: "gatsby-university",
        url: "https://github.com/gatsby-university/website",
        image: this.props.data.gatsbyUniversity.childImageSharp.fluid,
      }, 

      

      
      
    ]

    return (
      <Layout path="projects">
        <SEO title="Projects" />
          <Styles>
        <Container>
              <div className="title">
                Projects
              </div>

              <div className="my-courses">
                {
                  courses.map( (el) => {
                    return (
                      <a href={ el.url } target="_blank" rel="noopener noreferrer" key={ el.url }>
                        <div className="card">
                          <div className="card-image" >
                            <Img className="my-image" fluid={ el.image } alt={ el.title } />


                          </div>
                          <div className="card-content">
                            <div className="title is-6">
                            <FaGithub style={{marginRight: 3, position: "relative", top: 4}}></FaGithub> {
                              el.title
                            }
                            </div>


                            
                            
                          </div>
                          
                          
                        
                        </div>

                      </a>
                    )
                  })
                }

              </div>
        </Container>
          </Styles>
      </Layout>
    )
  }
}

export const query = graphql`
  {
    gatsbyUniversity: file(relativePath: { eq: "gatsby-university.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

  }

`

